import { XApp } from '@core/utils';

interface NazwaTechniczna {
  [key: string]: string;
}

const nazwaTechnicznaSetup = (insertedVal: string | undefined) => {
  const nazwaTechnicznaChars: NazwaTechniczna = {
    ę: 'e',
    ó: 'o',
    ą: 'a',
    ś: 's',
    ł: 'l',
    ż: 'z',
    ź: 'z',
    ć: 'c',
    ń: 'n',
    '!': '',
    '@': '',
    '#': '',
    $: '',
    '%': '',
    '^': '',
    '&': '',
    '*': '',
    '(': '',
    ')': '',
    '-': '',
    '+': '',
    '=': '',
    '{': '',
    '}': '',
    ';': '',
    ':': '',
    "'": '',
    '"': '',
    ',': '',
    '<': '',
    '.': '',
    '>': '',
    '/': '',
    '?': '',
    '~': '',
    '`': ''
  };

  const chars = Object.keys(nazwaTechnicznaChars).join('');
  const nazwaRegEx = new RegExp(`[${chars}]`, 'g');

  return typeof insertedVal === 'string'
    ? insertedVal
        .toLowerCase()
        .replaceAll(' ', '')
        .replaceAll('[', '')
        .replaceAll(']', '')
        .replaceAll('_', '')
        .replaceAll('\\', '')
        .replaceAll('-', '')
        .replace(
          nazwaRegEx,
          (m: keyof NazwaTechniczna) => nazwaTechnicznaChars[m]
        )
    : '';
};

const findStrInArr = (arr: unknown[], str: string) => {
  return !!arr.find((x) => x === str);
};

const overrideFilter = (loadEvent: any) => {
  if (!loadEvent.filter) return;

  const [firstFilterEl] = loadEvent.filter;

  if (typeof firstFilterEl === 'string') return;

  const andFound = findStrInArr(loadEvent.filter, 'and');

  if (firstFilterEl?.columnIndex === undefined && !andFound) {
    return;
  }

  const thirdEl = loadEvent.filter[2][0];
  const thirdElIsDefaultEl = typeof thirdEl === 'string';

  if (andFound && thirdElIsDefaultEl) return;

  loadEvent.defaultFilter = [...loadEvent.filter];

  const val = !thirdElIsDefaultEl ? thirdEl[2] : firstFilterEl[2];

  loadEvent.filter = ['NazwaTechniczna', 'contains', nazwaTechnicznaSetup(val)];
};

const determineStoreOnLoading = (customStore: any) => {
  if (customStore.onLoading) {
    return (e: unknown) => {
      overrideFilter(e);

      customStore.onLoading(e);
    };
  }

  return overrideFilter;
};

export const createDefaultDataSourceInitializer = (
  globalConfigNestedFields?: string[]
) => (endpoint: string, customStore?: any, customOptions?: any, searchPanelText?:any) => {

  // const ignoreSearchPanelText = typeof(searchPanelText) === 'string' && searchPanelText
  const ignoreSearchPanelText = searchPanelText !== '';

  let dataSource: {
    store?: unknown;
  } = {};

  let defaultStore = {
    type: 'odata',
    url: XApp.getApiUrlFromEndpoint(endpoint, globalConfigNestedFields),
    version: 4,
    key: 'Id',
    onLoading: ignoreSearchPanelText ? overrideFilter : () => {}
  };

  if (customStore) {
    const onLoading = determineStoreOnLoading(customStore);

    defaultStore = { ...defaultStore, ...customStore, onLoading };
  }

  if (customOptions) {
    dataSource = { ...customOptions };
  }

  dataSource.store = defaultStore;

  return dataSource;
};
